import { DynamicStandaloneTag, DynamicStandaloneTagProps } from '@/components/Tag';
import { componentTheme } from '@/styles/TrendingMenu';
import { StandaloneComponent } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type TrendingMenuTagProps = DynamicStandaloneTagProps;

export const TrendingMenuTagComponent: StandaloneComponent<TrendingMenuTagProps> = (props) => {
  return (
    <DynamicStandaloneTag
      {...mergeProps(
        {
          options: {
            theme: componentTheme('tag'),
          },
        },
        props
      )}
    />
  );
};
